import React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import ArrowLeft from 'components/icons/arrow-left';

const Arrow = styled(ArrowLeft)`
  height: 18px;
  width: 16px;
  fill: ${p => p.color};
  margin: 1rem;
  ${Styles.desktop`
    display: none;
  `}
`;

const LinkNoDecoration = styled(Link)`
  padding: 0 10px;
  position: fixed;
  z-index: ${Styles.zIndex.normal};
  top: calc(3px + env(safe-area-inset-top));
  left: 3px;
  ::before {
    color: transparent;
  }
  &:active,
  &:hover,
  &:link,
  &:visited {
    color: inherit;
  }
`;

const BackArrow = ({ to, color }: { to: string; color: string }) => (
  <LinkNoDecoration to={to}>
    <Arrow color={color} />
  </LinkNoDecoration>
);

export default BackArrow;
